<!-- Básica -->
<div class="row" *ngIf="isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Mínimo por imagem mm</mat-label>
                                <input matInput id="txtMinSiaqs" #txtMinSiaqs maxlength="2"
                                    formControlName="minimo_siaqs_mm" currencyMask (blur)="calcRangeSiaqs()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtMinSiaqs.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.minimo_siaqs_mm)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Máximo por imagem mm</mat-label>
                                <input matInput id="txtMaxSiaqs" #txtMaxSiaqs maxlength="2"
                                    formControlName="maximo_siaqs_mm" currencyMask (blur)="calcRangeSiaqs()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtMaxSiaqs.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.maximo_siaqs_mm)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Desvio Padrão por imagem mm</mat-label>
                                <input matInput id="txtDesvPadraoSiaqs" #txtDesvPadraoSiaqs maxlength="2"
                                    formControlName="desvio_padrao_siaqs_mm" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtDesvPadraoSiaqs.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.desvio_padrao_siaqs_mm)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Plantabilidade por imagem (%)</mat-label>
                                <input matInput id="txtPlantSiaqs" #txtPlantSiaqs maxlength="2"
                                    formControlName="plantabilidade_siaqs_prc" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPlantSiaqs.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.plantabilidade_siaqs_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Resultado por imagem</mat-label>
                                <input matInput id="txtResSiaqs" #txtResSiaqs maxlength="20"
                                    formControlName="resultado_siaqs" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtResSiaqs.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.resultado_siaqs)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Motivo Reprovação por imagem</mat-label>
                                <input matInput id="txtMotvReprSiaqs" #txtMotvReprSiaqs maxlength="200"
                                    formControlName="motivo_reprovacao_siaqs" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtMotvReprSiaqs.value.length}} / 200</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.motivo_reprovacao_siaqs)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Range por imagem mm</mat-label>
                                <input matInput id="txtMotvReprSiaqs" #txtMotvReprSiaqs maxlength="200"
                                    formControlName="range_siaqs_mm" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtMotvReprSiaqs.value.length}} / 200</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.range_siaqs_mm)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Disco recomendado por imagem | APOLLO – Maxim
                                </mat-label>
                                <mat-select #txtApolloMaxim formControlName="disco_recomendado_image_apollo_maxim"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterApollo($event.target.value)" />
                                    <mat-option *ngFor="let item of listApollo" [value]="item.name">
                                        {{ item.name | uppercase }}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{ iconEnableField }}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{ hasErrorFormControl(formulario.controls.disco_recomendado_image_apollo_maxim) }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Anel</mat-label>
                                <input matInput id="txtAnel" #txtAnel formControlName="anel" readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <i matSuffix class="{{ iconEnableField }}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{ hasErrorFormControl(formulario.controls.anel) }}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>

                <!-- <app-cd001-card-classificacao-basic-iv *ngIf="!collapseCard && area === 'Básica'"
                    [formulario]="formulario"></app-cd001-card-classificacao-basic-iv> -->

            </form>
        </mat-card>
    </div>
</div>

<!-- Comercial -->
<div class="row" *ngIf="isComercial">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard && area !== 'Básica'">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Mínimo por imagem mm</mat-label>
                                <input matInput id="txtMinSiaqs" #txtMinSiaqs maxlength="10"
                                    formControlName="minimo_siaqs_mm" currencyMask (blur)="calcRangeSiaqs()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtMinSiaqs.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.minimo_siaqs_mm)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Máximo por imagem mm</mat-label>
                                <input matInput id="txtMaxSiaqs" #txtMaxSiaqs maxlength="10"
                                    formControlName="maximo_siaqs_mm" currencyMask (blur)="calcRangeSiaqs()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtMaxSiaqs.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.maximo_siaqs_mm)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Range por imagem mm</mat-label>
                                <input matInput id="txtRangeSiaqs" #txtRangeSiaqs maxlength="10"
                                    formControlName="range_siaqs_mm" currencyMask readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRangeSiaqs.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.range_siaqs_mm)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Desvio Padrão por imagem mm</mat-label>
                                <input matInput id="txtDesvPadraoSiaqs" #txtDesvPadraoSiaqs maxlength="10"
                                    formControlName="desvio_padrao_siaqs_mm" currencyMask (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtDesvPadraoSiaqs.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.desvio_padrao_siaqs_mm)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Plantabilidade por imagem (%)</mat-label>
                                <input matInput id="txtPlantSiaqs" #txtPlantSiaqs maxlength="10"
                                    formControlName="plantabilidade_siaqs_prc" currencyMask (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPlantSiaqs.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.plantabilidade_siaqs_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div> -->
                        <div class="col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Resultado por imagem</mat-label>
                                <input matInput id="txtResSiaqs" #txtResSiaqs maxlength="20"
                                    formControlName="resultado_siaqs" readonly
                                    [class]="classResultadoSiaqs == ''?'InputBlockColor' : ''"
                                    [ngStyle]="{'background-color': classResultadoSiaqs } ">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtResSiaqs.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.resultado_siaqs)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Motivo Reprovação por imagem</mat-label>
                                <input matInput id="txtMotvReprSiaqs" #txtMotvReprSiaqs maxlength="200"
                                    formControlName="motivo_reprovacao_siaqs" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtMotvReprSiaqs.value.length}} / 200</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.motivo_reprovacao_siaqs)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Usuário</mat-label>
                                <input matInput id="txtUsuario" #txtUsuario maxlength="100" formControlName="usuario"
                                    readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtUsuario.value.length}} / 100</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.usuario)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Disco recomendado por imagem | SOCIDISCO –
                                    Maxim</mat-label>
                                <mat-select #txtSocidiscoMaxim formControlName="disco_recomendado_image_socidisco_maxim"
                                    disableCenteringOption>
                                    <mat-option *ngFor="let item of listSocidisco" [value]="item.name">
                                        {{ item.name | uppercase }}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{ iconEnableField }}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{ hasErrorFormControl(formulario.controls.disco_recomendado_image_socidisco_maxim) }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Disco recomendado por imagem | SOCIDISCO –
                                    TSI</mat-label>
                                <mat-select #txtSocidiscoTsi formControlName="disco_recomendado_image_socidisco_tsi"
                                    disableCenteringOption>
                                    <mat-option *ngFor="let item of listSocidisco" [value]="item.name">
                                        {{ item.name | uppercase }}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{ iconEnableField }}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{ hasErrorFormControl(formulario.controls.disco_recomendado_image_socidisco_tsi) }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Disco recomendado por imagem | APOLLO –
                                    Maxim</mat-label>
                                <mat-select #txtApolloMaxim formControlName="disco_recomendado_image_apollo_maxim"
                                    disableCenteringOption>
                                    <mat-option *ngFor="let item of listApollo" [value]="item.name">
                                        {{ item.name | uppercase }}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{ iconEnableField }}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{ hasErrorFormControl(formulario.controls.disco_recomendado_image_apollo_maxim) }}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Disco recomendado por imagem | APOLLO –
                                    TSI</mat-label>
                                <mat-select #txtApolloTSI formControlName="disco_recomendado_image_apollo_tsi"
                                    disableCenteringOption>
                                    <mat-option *ngFor="let item of listApollo" [value]="item.name">
                                        {{ item.name | uppercase }}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{ iconEnableField }}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{ hasErrorFormControl(formulario.controls.disco_recomendado_image_apollo_tsi) }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Observação</mat-label>
                                <textarea matInput id="txtObs" #txtObs maxlength="255"
                                    formControlName="observacoes"></textarea>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.observacoes)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>

                <!-- <app-cd001-card-classificacao-basic-iv *ngIf="!collapseCard && area === 'Básica'" [formulario]="formulario"></app-cd001-card-classificacao-basic-iv>                 -->

            </form>
        </mat-card>
    </div>
</div>